"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const clsx = require("../../../chunks/clsx-CBkIpawf.js");
const foundations_icons_Icon = require("../../../foundations/icons/Icon.js");
const foundations_typography_Text_Text = require("../../../foundations/typography/Text/Text.js");
const message = "_message_u8hzz_1";
const messageMain = "_messageMain_u8hzz_13";
const messageContent = "_messageContent_u8hzz_20";
const messageTitle = "_messageTitle_u8hzz_21";
const styles = {
  message,
  messageMain,
  messageContent,
  messageTitle,
  "message-info": "_message-info_u8hzz_29",
  "message-neutral": "_message-neutral_u8hzz_35"
};
const Message = ({
  children,
  className,
  icon,
  titleHeadingLevel,
  title,
  variant = "info",
  ...props
}) => {
  return /* @__PURE__ */ jsxRuntime.jsxs("div", { className: clsx.clsx(styles.message, styles["message-" + variant], className), ...props, children: [
    icon && /* @__PURE__ */ jsxRuntime.jsx(foundations_icons_Icon.Icon, { variant: icon, "aria-hidden": "true" }),
    /* @__PURE__ */ jsxRuntime.jsxs("div", { className: styles.messageMain, children: [
      title && /* @__PURE__ */ jsxRuntime.jsx(
        foundations_typography_Text_Text.Text,
        {
          variant: "text-body-head",
          className: styles.messageTitle,
          component: titleHeadingLevel || "h3",
          children: title
        }
      ),
      children && (React.isValidElement(children) ? children : /* @__PURE__ */ jsxRuntime.jsx(foundations_typography_Text_Text.P, { className: styles.messageContent, children }))
    ] })
  ] });
};
exports.Message = Message;
